/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_About_TitleInputs */

const en_vc_about_title = /** @type {(inputs: Vc_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is VectorCraft?`)
};

const zh_vc_about_title = /** @type {(inputs: Vc_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 是什么？`)
};

/**
* | output |
* | --- |
* | "What is VectorCraft?" |
*
* @param {Vc_About_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_about_title = /** @type {((inputs?: Vc_About_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_About_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_about_title(inputs)
	return zh_vc_about_title(inputs)
});
export { vc_about_title as "vc.about.title" }